import { useEffect, useContext, useState } from "react";
import UserContext from "./../contexts/UserContext";
import Utils from "./../Utils";
import axios from "axios";

const Login = (props) => {
  const [activeTab, setActiveTab] = useState("hotelRep");

  const { authenticate, goSSO, phLogin } = useContext(UserContext);

  // Set body class for Login page
  useEffect(() => {
    if(Utils.isLoggedIn()) {
      if(Utils.isHR()) {
        window.location.href = process.env.PUBLIC_URL + '/hotel-representative-dashboard';
      }
      if(Utils.isPhotographer()) {
        window.location.href = process.env.PUBLIC_URL + '/photographer-dashboard';
      }
    }
    document.body.className = "bg-gray-100 flex items-center justify-center min-h-screen";
    return () => {
      document.body.className = "bg-gray-50";
    };
  }, []);

  /* Hotel Representative Login */
  const handleSSOLogin = (e) => {
    e.preventDefault();
    const body = {
      name: "Ritesh Kumar",
      email: "riteshbksc@gmail.com",
      marriott_emp: "1234",
    };

    goSSO(body, (data) => {
      window.alert(data.message);
      console.log(data);
      if (data.success) {
        if (data.userData && data.userData.isHR) {
          if(data.userData.hotel_id != null && data.userData.hotel_id != '' && data.userData.hotel_id != undefined) {
            window.location.href = process.env.PUBLIC_URL + "/hotel-representative-dashboard";
          }
          else {
            window.location.href = process.env.PUBLIC_URL + "/hotel-representative-first-login";
          }
        } else {
          window.location.href = process.env.PUBLIC_URL + "/photographer-dashboard";
        }
      } else {
        window.alert(data.message);
      }
    });
  };

  
  /* Photographer Login */
  const photographerLogin = (e) => {
    e.preventDefault();
    const body = {
      username: e.target.username.value,
      password: e.target.password.value,
    };
    console.log(body);

    phLogin(body, (data) => {
      window.alert(data.message);
      console.log(data);
      if (data.success) {
        if (data.userData && data.userData.isPG) {
          window.location.href = process.env.PUBLIC_URL + "/photographer-dashboard";
        } else {
          window.location.href = process.env.PUBLIC_URL + "/photographer-dashboard";
        }
      } else {
        window.alert(data.message);
      }
    });
  };

  return (
    <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-xl loginWrap">
      <div className="block pb-8 content-center">
        <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Marriott Bonvoy" className="logo" />
      </div>
      <h2 className="text-2xl font-bold text-center mb-6">Login</h2>

      <div className="mb-4 flex border-b border-gray-200 tabs">
        {["hotelRep", "photographer"].map((tab) => (
          <button
            key={tab}
            className={`tab-button bg-gray-100 flex-1 py-2 text-center text-gray-600 hover:text-blue-600 focus:outline-none ${
              activeTab === tab ? "active" : ""
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab === "hotelRep" && (
              <>
                <i className="fa-solid fa-hotel"></i> Hotel Representative
              </>
            )}
            {tab === "photographer" && (
              <>
                <i className="fa-solid fa-camera"></i> Photographer
              </>
            )}
          </button>
        ))}
      </div>
      {activeTab === "hotelRep" && (
        <div id="hotelRepTabContent">
          <div className="flex justify-center p-12 bg-gray-100">
            <button type="button" onClick={handleSSOLogin} className="btn text-white font-bold py-2 px-4 rounded w-full">
              Sign in with Marriott SSO
            </button>
          </div>
        </div>
      )}
      {activeTab === "photographer" && (
        <div id="photographerTabContent">
          <form method="get" action="photographer-dashboard" onSubmit={photographerLogin}>
            <div className="mb-4">
              <label htmlFor="username" className="block text-gray-700 text-sm font-bold mb-2">
                Username:
              </label>
              <input
                type="text"
                id="username"
                name="username"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter your username"
              />
            </div>
            <div className="mb-6">
              <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">
                Password:
              </label>
              <input
                type="password"
                id="password"
                name="password"
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Enter your password"
              />
            </div>
            <div className="flex items-center justify-between pb-4">
              <button type="submit" className="btn text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full">
                Login
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default Login;
